
export * from '@comped/fe-shared';

export type NoShowError = Error & { no_show_error?: true };
export function noShowError(message?: string) {
    const err: NoShowError = new Error(message ?? 'cancelled');
    err.no_show_error = true;
    return err;
}
